import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import * as globals from '@reusable/services/globals';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable()
export class TeamCoreCategoriesService {
  responseData: any;
  handleError: any;

  constructor(private router: Router, private gtn: globals.GetTokenNow, private httpClient: HttpClient) {}

  viewCoreCategory(coreCategoryId) {
    return this.httpClient.get(`${globals.domain}/core/categories/${coreCategoryId}/view`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  editCoreCategory(coreCategoryId) {
    return this.httpClient.get(`${globals.domain}/core/categories/${coreCategoryId}/edit/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  updateCoreCategory(coreCategoryId, body) {
    return this.httpClient
      .put(`${globals.domain}/core/categories/${coreCategoryId}/update/`, JSON.stringify(body), this.gtn.getHeaders())
      .pipe(map(res => res as any));
  }
  // requestId ,
  addCoreCategory(body) {
    return this.httpClient.post(`${globals.domain}/core/categories/add/`, JSON.stringify(body), this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  removeCoreCategory(coreCategoryId) {
    return this.httpClient.delete(`${globals.domain}/core/categories/${coreCategoryId}/remove/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  restoreCoreCategory(coreCategoryId) {
    return this.httpClient.put(`${globals.domain}/core/categories/${coreCategoryId}/restore/`, {}, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  rearrangeCoreCategory(body) {
    return this.httpClient.put(`${globals.domain}/core/categories/rearrange/`, JSON.stringify(body), this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  listCoreCategories(sort, records, pageNumber, queries?): Observable<any> {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/core/categories/list/sortBy-${sort}/${records}/${pageNumber}/`, updateQueries)
      .pipe(map(res => res as any));
  }
}